import React from 'react';
import { Box } from '@mui/material';
import { SPARK_PATH, FONT_DISPLAY } from '../Auth/brandTokens';

/**
 * Dragonsframe brand mark: a four-point ember "spark" (a flame and a frame in one), per the
 * Claude Design identity system. Solid ember by default, or the amber→ember→pink gradient.
 */
export const BrandMark: React.FC<{ size?: number; gradient?: boolean; color?: string; flicker?: boolean }> = ({
  size = 22,
  gradient = false,
  color = '#FF5B2E',
  flicker = false,
}) => {
  const gid = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ display: 'block', ...(flicker ? { animation: 'dfFlick 4s ease-in-out infinite' } : {}) }}
      role="img"
      aria-label="Dragonsframe"
    >
      {gradient && (
        <defs>
          <linearGradient id={`${gid}-g`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FFC24B" />
            <stop offset="0.5" stopColor="#FF5B2E" />
            <stop offset="1" stopColor="#FF2D6B" />
          </linearGradient>
        </defs>
      )}
      <path d={SPARK_PATH} fill={gradient ? `url(#${gid}-g)` : color} />
    </svg>
  );
};

/** Mark + "Dragonsframe" wordmark ("frame" in ember). */
export const BrandLockup: React.FC<{ size?: number; textColor?: string; ember?: string; flicker?: boolean }> = ({
  size = 22,
  textColor = 'inherit',
  ember = '#FF5B2E',
  flicker = false,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: `${Math.round(size * 0.45)}px` }}>
    <BrandMark size={size} color={ember} flicker={flicker} />
    <Box
      component="span"
      sx={{
        fontFamily: FONT_DISPLAY,
        fontWeight: 800,
        fontSize: size * 0.92,
        letterSpacing: '-0.01em',
        lineHeight: 1,
        color: textColor,
      }}
    >
      Dragons<Box component="span" sx={{ color: ember }}>frame</Box>
    </Box>
  </Box>
);

export default BrandMark;
